import Vue from 'vue'
import * as Account from 'api/account'

export default {
  methods: {
    async resetPassword (user) {
      if (user.$$reset_password_loading > 0) return
      if (!await this.$dangerConfirm('确定要重置密码吗？', '重置密码')) return
      this.$guard(user, '$$reset_password_loading')(async () => {
        await Account.resetPassword({user_uid: user.uid})
        this.$message.success('重置成功')
      })
    },
    getOriginPassword (user) {
      this.$guard(user, '$$get_password_loading')(async () => {
        Vue.set(user, '$$password', await Account.getOriginPassword({user_uid: user.uid}))
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/admin/account/passwordMixin.js